import { SyncService } from "frontend/services/syncService";
import { useCollaboratorsInVideoChat } from "frontend/subscriptions";
import { FooterButton, FooterButtonGroup } from "../footer";
import { RW } from "shared/datamodel/replicache-wrapper/mutators";
import VideoCallParticipantsChip from "./video-call-participants-chip";
import style from "./video-call-button.module.css";

const VideoCallIcon = ({ color }: { color: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
      <path
        d="M19.1373 10.5581V16.3271L23.625 20.25V6.75L19.1373 10.5581Z"
        stroke={color}
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.37288 6.75H15.7129C17.3644 6.75 19.125 8.10338 19.125 9.90338V19.1239C19.1277 19.4182 19.0139 19.7017 18.8084 19.9124C18.6029 20.1232 18.3224 20.2441 18.0281 20.2489H6.3585C4.48312 20.2489 3.375 18.5614 3.375 16.8739L3.38625 7.87388C3.36509 7.73173 3.37505 7.58669 3.41545 7.44878C3.45585 7.31087 3.52573 7.18338 3.62025 7.07513C3.71362 6.96821 3.82985 6.88368 3.96033 6.82779C4.09081 6.7719 4.23219 6.74608 4.374 6.75225L4.37288 6.75Z"
        stroke={color}
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const VideoCallHangupIcon = ({ color }: { color: string }) => {
  return (
    <svg width="27" height="13" viewBox="0 0 27 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25.4448 8.60481L22.2625 11.7881L16.6923 9.40188L17.4875 6.21901C14.9074 5.34371 12.1105 5.34415 9.53065 6.22027L10.3268 9.40289L4.75742 11.7908L1.57417 8.60859C1.15204 8.1866 0.91484 7.6142 0.914746 7.01732C0.914651 6.42044 1.15167 5.84797 1.57366 5.42584C4.86558 2.51017 9.11076 0.9001 13.5082 0.899404C17.9057 0.898708 22.1514 2.50744 25.4443 5.42206C25.8664 5.84405 26.1036 6.41645 26.1037 7.01333C26.1038 7.61021 25.8668 8.18268 25.4448 8.60481Z"
        stroke={color}
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export function VideoCallButton({
  syncService,
  onClick,
  isAnonymousUser,
}: {
  syncService: SyncService<RW> | null;
  onClick: () => void;
  isAnonymousUser: boolean;
}) {
  // TODO: this gets called on every mouse-move of every collaborator
  const videoChat = useCollaboratorsInVideoChat(syncService?.getReplicache());
  const numberOfOthers = videoChat.others?.length ?? 0;
  const ongoingChat = numberOfOthers > 0 || !!videoChat.myVideoPresence;
  const numberOfPeopleInCall = numberOfOthers + (videoChat.myVideoPresence ? 1 : 0);

  return (
    <>
      <FooterButtonGroup className={ongoingChat ? style.videoCallOngoingButton : ""}>
        <FooterButton
          tooltip="Video chat"
          onClick={videoChat.myVideoPresence ? null : onClick}
          disabled={false}
          testid="video-call-button"
        >
          {ongoingChat ? (
            <>
              <VideoCallIcon color="#00b875" />
              <VideoCallParticipantsChip count={numberOfPeopleInCall} />
            </>
          ) : (
            <VideoCallIcon color="var(--dark)" />
          )}
        </FooterButton>
      </FooterButtonGroup>

      {videoChat.myVideoPresence && !isAnonymousUser && (
        <FooterButtonGroup className={style.videoCallOngoingButtonHangup}>
          <FooterButton tooltip="Leave call" onClick={onClick} disabled={false} testid="video-call-button-hangup">
            <VideoCallHangupIcon color="#ff6a5f" />
          </FooterButton>
        </FooterButtonGroup>
      )}
    </>
  );
}
